import Navbar from '../../Components/Common/Navbar';
import Footer from '../../Components/Common/Footer';
import PackagesSection from '../../Components/Sections/PackagesSection';
import PDFFeatureSection from '../../Components/Sections/PDFFeatureSection';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useIsMobile } from '../../Hooks/useIsMobile';
import { Container } from '../../Components/ui/Container';
import { Button } from '../../Components/ui/Button';
import { checkLPData, getImagePath, isFlashOfferOn } from '../../Utils/Utilities';
import { useEffect } from 'react';
import apiService from '../../Utils/APIService';
import { useBrand } from '../../Utils/BrandContext';
import { PACKAGES, getOfferPrice, currPage, PAGE_EDITION_MAPPER } from '../../Constants/Packages';


const Intro = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { brand: activeBrand } = useBrand();
    const brandLogo = activeBrand === 'bz' ? getImagePath("/Images/Biziverse.png") : getImagePath("/Images/QikERP.png");

            const pageKey = currPage?.toLowerCase();
            const editionIds = PAGE_EDITION_MAPPER[pageKey]?.editionIds || [];
            const editionId = editionIds[0]; 

    const isMobile = useIsMobile();
    const flashOfferOn = isFlashOfferOn();
    const isMobileDevice = typeof window !== 'undefined' && /Mobi|Android/i.test(navigator.userAgent);

    const PIXEL_ID = "1652655355901269";
    const EVENT_NAME = "PageView";

    // --- META PIXEL INTEGRATION START ---
    useEffect(() => {
        if (window.fbq) {
        window.fbq("track", EVENT_NAME);
        return;
        }

        // Standard Meta Boilerplate (Never changes)
        const fbq = function () {
        fbq.callMethod
            ? fbq.callMethod.apply(fbq, arguments)
            : fbq.queue.push(arguments);
        };
        if (!window._fbq) window._fbq = fbq;
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = "2.0";
        fbq.queue = [];
        window.fbq = fbq;

        const script = document.createElement("script");
        script.async = true;
        script.src = "https://connect.facebook.net/en_US/fbevents.js";
        const firstScript = document.getElementsByTagName("script")[0];
        if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
        } else {
        document.head.appendChild(script);
        }

        // Use the variables here
        window.fbq("init", PIXEL_ID);
        window.fbq("track", EVENT_NAME);
    }, []);

    const sendSensor = (actionID, actionTxt = '') => {
        const allDataRaw = localStorage.getItem('allData');
        if (!allDataRaw) return;
        const allData = JSON.parse(allDataRaw);
        const leadInfo = allData.info ? JSON.parse(allData.info) : [];
        const mobile = allData.mobile || '';
        const leadPIN = leadInfo[0]?.LeadO || '';
        apiService.sendCallSensorReq(actionID, actionTxt, { leadPIN, mobile, device: isMobileDevice ? 'M' : 'D' });
    };

    useEffect(() => {
        if (!checkLPData('intro', searchParams)) return;
    }, []);

    const handleKnowMore = () => {
        // Clone current parameters and append z=main
        const currentParams = new URLSearchParams(searchParams);
        currentParams.set('z', 'main');
        navigate(`/Guide?${currentParams.toString()}`);
    };
    const handleNavbarBuyNow = () => {
        const packagesSection = document.getElementById('simplePricing');
        if (packagesSection) {
            window.scrollTo({
                top: packagesSection.offsetTop - 70,
                behavior: 'smooth'
            });
        }
    };

    const handleScrollToPricing = () => {
        const packagesSection = document.getElementById('simplePricing');
        if (packagesSection) {
            window.scrollTo({
                top: packagesSection.offsetTop - 70,
                behavior: 'smooth'
            });
        }
    };


    const handleBuyNow = (editionId) => {
        // const finalEdnId = (editionId && typeof editionId !== 'object') ? editionId : 34;
        // const allDataRaw = localStorage.getItem('allData');

        // if (allDataRaw) {
        //     const allData = JSON.parse(allDataRaw);
        //     const leadInfo = allData.info ? JSON.parse(allData.info) : [];

        //     localStorage.setItem("selEdn", finalEdnId);
        //     localStorage.setItem("selPrd", "YY");
        //     localStorage.removeItem("cpn");
        //     localStorage.setItem("guidePG", window.location.pathname.substring(1));

        //     const cioData = [{ 'i': allData.mobile, 'o': leadInfo[0]?.LeadO }];
        //     localStorage.setItem('cio', JSON.stringify(cioData));

        //     window.location.href = "/Html/External/BZPay.html";
        // } else {
        //     handleScrollToPricing();
        // }
        const currentParams = new URLSearchParams(searchParams);
        // currentParams.set('z', 'main');
        currentParams.set('scroll', 'pricing');
        navigate(`/${currPage}?${currentParams.toString()}`);
    };

    return (
        <div className={`min-h-screen bg-white ${!isMobile ? 'pt-12 md:pt-16' : ''}`} id="intro-page">
            <noscript>
                <img
                height="1"
                width="1"
                style={{ display: "none" }}
                src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=${EVENT_NAME}&noscript=1`}
                />
            </noscript>

            <Navbar
                logo={brandLogo}
                isFromGQik={true}
                onBuyNowClick={handleNavbarBuyNow}
            />

            <main>
                <PDFFeatureSection
                    id="introDemo"
                    title="Quick Intro"
                    slogan="Explore how you can Transform Business with QikERP"
                    pdfUrl={getImagePath("/pdfs/QikERP Demo Intro.pdf")}
                    thumbnailUrl={getImagePath("/Images/IntroThumb.png")}
                    thumbnailPosition="right"
                    logo={brandLogo}
                    titleWeb={
                        isMobile ? (
                            <div className="flex flex-col items-center">
                                <div className="flex flex-col items-center relative">
                                    <img src={brandLogo} alt="Logo" className="h-[70px] w-auto object-contain" />
                                    {!brandLogo.includes('Biziverse.png') && (
                                        <div className="flex flex-col items-center absolute" style={{ top: '65px', right: '0.75rem' }}>
                                            <span className="text-sm text-primary font-bold mb-0.5">by</span>
                                            <img src={getImagePath("/Images/Biziverse.png")} alt="Biziverse" className="h-[26px] w-auto object-contain" />
                                        </div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <h1 className="text-[40px] font-bold text-primary mb-0 flex items-center gap-6" style={{ textShadow: '2px 2px 3px rgb(0 0 0 / 10%)' }}>
                                Introducing
                                <div className="flex flex-col items-center relative inline-flex">
                                    <img src={brandLogo} alt="Logo" className="h-[85px] w-auto object-contain" />
                                    {!brandLogo.includes('Biziverse.png') && (
                                        <div className="flex flex-col items-center absolute" style={{ top: '85px', right: '1.25rem' }}>
                                        </div>
                                    )}
                                </div>
                            </h1>
                        )
                    }
                    sloganWeb={
                        <>
                            {!isMobile && <p className={`${isMobile ? 'text-[15px] mt-10' : 'text-xl'} font-normal text-text-primary leading-relaxed`}>
                                <span className="font-bold text-text-primary">Easy & Powerful</span> Tools to{' '}
                                <span className="font-bold text-text-primary">Accelerate Business.</span>
                            </p>}
                            {isMobile && (
                                // <h1 className="text-[28px] sm:text-4xl md:text-5xl lg:text-5xl font-bold text-center leading-tight mb-12 mt-10 md:mb-16"><span className="text-primary">Easy</span> &amp; <span className="text-primary">Powerful</span> Tools to <br className="md:hidden" /><span className="text-primary">Accelerate Business</span></h1>
                                // <h1 className={`text-[24px] sm:text-4xl md:text-5xl lg:text-5xl font-bold text-center  px-5 pt-[25px] mb-12 md:mb-12`}>
                                //     <span className="text-primary">Easy</span> & <span className="text-primary">Powerful</span><br className="md:hidden" /> Tools to <span className='text-primary'><br className="md:hidden" />Accelerate Business</span>
                                // </h1>
                                <></>
                            )}
                            {!isMobile && (
                                <p className="text-xl font-normal text-text-primary leading-relaxed mt-4">
                                    Everything you need @ <span className="font-bold text-text-primary">Truly Lowest Price</span>
                                    <br />
                                    & <span className="font-bold text-text-primary">Best Support</span> @ <span className="font-bold text-text-primary">Zero Risk.</span>
                                </p>
                            )}
                        </>
                    }
                    buttonTextWeb="Start Subscription"
                    onButtonClick={handleBuyNow}
                    onButtonClickWeb={handleBuyNow}
                    className="bg-white "
                />
                {/* Section 2: Product Preview */}
                <PDFFeatureSection
                    id="productReview"
                    title="Product Preview"
                    slogan="10 Minutes to Transform your Business!"
                    // buttonText="Buy Now"
                    pdfUrl="https://qikerp.com/QikERP/pdfs/QikERP%20Demo%20Intro.pdf"
                    thumbnailUrl={getImagePath("/Images/IntroThumb.png")}
                    thumbnailPosition="left"
                    titleWeb="Product Preview"
                    sloganWeb={
                        isMobile ? (
                            <>
                                {/* <p>
                                    Discover how <span className="font-bold text-text-primary">QikERP</span> can transform your business operations.
                                </p>
                                <p>
                                    Watch our detailed <span className="font-bold text-text-primary">Product Demo</span> and explore{' '}
                                    <span className="font-bold text-text-primary">Screenshots</span> to see all features in action.
                                </p> */}
                            </>
                        ) : (
                            <div className="flex flex-wrap gap-3 mt-5">
                                {[
                                    { name: 'CRM', icon: 'fa fa-users' },
                                    { name: 'Quotes', icon: 'fas fa-file-alt' },
                                    { name: 'Orders', icon: 'fas fa-box' },
                                    { name: 'Billing', icon: 'fas fa-money-bill-wave' },
                                    { name: 'E-Way Bill', icon: 'fas fa-truck' },
                                    { name: 'E-Invoice', icon: 'fas fa-file-invoice' },
                                    { name: 'Accounts', icon: 'fas fa-inr' },
                                    { name: 'GSTR1 & 3B', icon: 'fas fa-landmark' },
                                    { name: 'Recovery', icon: 'fas fa-hand-holding-usd' },
                                    { name: 'Inventory', icon: 'fas fa-warehouse' },
                                    { name: 'Batches', icon: 'fas fa-layer-group' },
                                    { name: 'BOM', icon: 'fas fa-clipboard-list' },
                                    { name: 'Purchase Orders', icon: 'fa fa-shopping-cart' },
                                    { name: 'Suppliers Invoices', icon: 'fas fa-user-tie' },
                                    { name: 'MRP', icon: 'fas fa-calculator' },
                                    { name: 'Projects', icon: 'fas fa-project-diagram' },
                                    { name: 'Manufacturing', icon: 'fas fa-industry' },
                                    { name: 'Tasks', icon: 'fas fa-tasks' },
                                    { name: 'Support Ticketing', icon: 'fas fa-headset' },
                                    { name: 'Contracts', icon: 'fas fa-file-contract' },
                                ].map((feature, idx) => (
                                    <div key={idx} className="flex items-center gap-2 border border-border rounded px-3 py-2 bg-white">
                                        <i className={`${feature.icon} flex-shrink-0 text-primary`} style={{ fontSize: '16px' }}></i>
                                        <span className="text-sm text-text-primary font-bold">{feature.name}</span>
                                    </div>
                                ))}
                            </div>
                        )
                    }
                    buttonTextWeb="Buy Now"
                    onButtonClick={handleBuyNow}
                    onButtonClickWeb={handleBuyNow}
                    className="bg-white "

                />
                {/* Section 3: Packages Section */}
                {/* <PackagesSection
                    onBuyNow={handleBuyNow}
                    pageName="GQIK"
                    showCoupons={true}
                    flashOfferOn={flashOfferOn}
                    onCouponView={(editionName) => sendSensor(109, `View Coupons (${editionName})`)}
                    onPackageClick={(pkgId) => sendSensor(pkgId)}
                    onPackageView={() => sendSensor(4, 'Package View')}
                    onGetOffer={() => sendSensor(4, 'Get Offer Clicked')}
                /> */}
                {/* Final Section: Know More */}
                <section className="pb-8 bg-white md:pb-16 lg:pb-20 text-center">
                    <Container>
                        <div className="flex md:flex-row flex-col justify-center items-center gap-4 px-14">
                            <Button
                                variant="primaryDarkBlue"
                                size={!isMobile ? "lg" : "default"}
                                onClick={handleBuyNow}
                                className="md:w-[20%] w-full"
                            >
                                Get Started
                            </Button>
                            <Button
                                variant="secondaryDarkBlue"
                                size={!isMobile ? "lg" : "default"}
                                onClick={handleKnowMore}
                                className="md:w-[20%] w-full"
                            >
                                Know More
                            </Button>
                        </div>
                    </Container>
                </section>
            </main>

            <Footer />
        </div>
    );
};

export default Intro;